import React, { useEffect, useState } from 'react'
import './BPLoading.css'
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import styled, { keyframes } from 'styled-components';

function BPLoading({isUpdating}) {
  const [time, setTime] = useState((2 * 30) + 0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(intervalId);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;


  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', paddingTop: '0px'}}>
    <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <p style={{marginTop: '10px', color: 'var(--tst-color)'}}>{isUpdating? 'Updating ': 'Preparing '} your page report...</p>
    {/* <p style={{color: 'gray', marginBlock: '50px', fontFamily: 'Quicksand'}}>It will take approximately <strong>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</strong> to retrieve the data as we ensure it is the most current and up-to-date information available</p> */}


    {/* <NOTE><ReportProblemIcon /> <p>The Site Report Project is in Beta Mode—new insights and optimizations
       are on the way, but it may not work perfectly yet!</p></NOTE> */}
    </div>
  )
}

export default BPLoading


const ColorEffect = keyframes`
  0%{
    color: var(--tst-color);
    filter: brightness(100%);
  }

  50% {
    color: var(--tst-color);
    filter: brightness(130%);
  }

  100% {
    color: var(--tst-color);
    filter: brightness(100%);
  }
`

const NOTE = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 60px;

  > .MuiSvgIcon-root {
    animation: ${ColorEffect} 3s ease-in-out infinite;
  }

  > p {
    animation: ${ColorEffect} 3s ease-in-out infinite;
  }
`